import type { RootState } from '@/rootState';

export const getUserId = ({ sharedReducer: { userData } }: RootState) => userData.id;
export const getUserPlayMode = ({ sharedReducer: { userData } }: RootState) => userData.play_mode;
export const getSteps = ({ learningPathReducer: { steps } }: RootState) => steps;
